<template>
  <v-container fluid>
    <v-row>
      <!-- preset props -->
      <v-col cols="3">
        <wapi-panel :title="'Свойства территории'">
          <template v-slot:content>
            <v-text-field v-model="preset.id" label="Идентификатор территории" disabled></v-text-field>
            <v-text-field v-model="preset.name" label="Название территории" disabled></v-text-field>
            <v-text-field v-model="userName" label="Клиент" disabled></v-text-field>
            <v-radio-group v-model="preset.status">
              <v-radio :label="`Активный`" :value="1" dense></v-radio>
              <v-radio :label="`Не активный`" :value="0" dense></v-radio>
            </v-radio-group>
            <v-text-field v-model="areaText" label="Площадь территории" disabled></v-text-field>

            <div v-if="isAdmin" class="d-flex justify-end">
              <v-btn text color="primary" @click="savePreset(preset)" left>Сохранить</v-btn>

              <v-btn text color="error" @click="deletePreset()" right>Удалить</v-btn>
            </div>
          </template>
        </wapi-panel>
      </v-col>
      <v-col cols="9">
        <v-row no-gutters>
          <v-col>
            <!-- map -->
            <wapi-panel :title="'Территория'" :spacing="false">
              <template v-slot:content>
                <div style="height: 415px;">
                  <l-map ref="map" :class="'wapi_map__map'" :zoom="zoom">
                    <l-tile-layer url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"></l-tile-layer>
                    <l-geo-json
                      ref="geoJsonLayer"
                      v-if="show"
                      :geojson="geojson"
                      :options="geoJsonOptions"
                    />
                    <l-marker
                      v-for="marker in markers"
                      v-bind:key="marker.id"
                      :lat-lng="[marker.latitude, marker.longitude]"
                    ></l-marker>
                  </l-map>
                </div>
              </template>
            </wapi-panel>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <preset-parameters
              v-model="markers"
              :preset="preset"
              :coordinateOrder="coordinateOrder"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col></v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3"></v-col>
      <v-col></v-col>
    </v-row>

    <!--диалоговаое окно удаления  -->
    <v-row>
      <v-dialog v-model="deleteDialog" max-width="290">
        <v-card>
          <v-card-title class="headline">Удаление</v-card-title>

          <v-card-text>Уверены что хотите удалить территорию {{ preset.id }}?</v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="green darken-1" text @click="deleteDialog = false">Отмена</v-btn>

            <v-btn color="green darken-1" text @click="confirmDeletePreset()">Удалить</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import WapiContract from "../../models/contract/WapiContract";
import { areaInKm2, areaInHa } from "../../helpers/common";
import PresetParameters from "./components/PresetParameters.vue";
import WapiPanel from "../../components/WapiPanel";
import { uniqWith } from "lodash";

export default {
  name: "PresetDetailsView",
  title: "Территория",
  components: {
    PresetParameters,
    WapiPanel
  },
  props: {
    userId: String,
    presetId: String
  },
  watch: {
    async presetId() {
      this.reset();
      await this.load();
    }
  },
  async mounted() {
    this.users = await this.$store.dispatch("FETCH_USERS");
    this.domains = await this.$store.dispatch("FETCH_DOMAINS");
    this.preset = await this.$store.dispatch("FETCH_PRESET", {
      id: this.presetId,
      user_id: this.userId
    });
    this.geojson = this.preset.geoJson;
    this.bounds = this.$refs.geoJsonLayer.getBounds();

    this.onChangeUser(this.userId);
  },
  computed: {
    userName() {
      if (!this.userId) return "";
      if (!this.users.length) return "";
      return this.users.find(x => x.id === this.userId).name;
    },
    areaText() {
      if (!this.preset.area) return "";
      return `${Math.round(
        areaInKm2(this.preset.geoJson.geometry)
      )} км² / ${Math.round(areaInHa(this.preset.geoJson.geometry))} га`;
    },
    isAdmin() {
      return this.$store.getters.IS_ADMIN;
    }
  },
  data: function() {
    return {
      domainName: "",
      domains: [],
      markers: [],
      presetParameters: [],
      contractModel: new WapiContract(),
      geoJsonOptions: {
        onEachFeature: (feature, layer) => {
          const bounds = layer.getBounds();
          layer.getLatLng = function() {
            return this.getBounds().getCenter();
          };
          layer.setLatLng = function() {};
          layer._latlng = layer.getLatLng();
          this.$refs.map.mapObject.fitBounds(bounds);
          this.zoom = this.zoom - 5;
        }
      },
      activityItems: [
        {
          code: 1,
          label: "Активный"
        },
        {
          code: 0,
          label: "Не активный"
        }
      ],
      dvariants: [],
      predicts: [],
      domain: "",
      users: [],
      presets: [],
      presetsViewModel: [],
      parameters: [],
      parametersLayers: [],
      ShowForecastSettings: false,
      show: true,
      enableTooltip: true,
      geojson: null,
      fillColor: "#e4ce7f",
      bounds: null,
      preset: {},
      deleteDialog: false,
      coordinateOrder: [1, 0],
      zoom: 13
    };
  },
  methods: {
    async load() {
      this.users = await this.$store.dispatch("FETCH_USERS");
      this.preset = await this.$store.dispatch("FETCH_PRESET", {
        id: this.presetId,
        user_id: this.userId
      });
      this.geojson = this.preset.geoJson;
      this.bounds = this.$refs.geoJsonLayer.getBounds();
      this.onChangeUser(this.userId);
    },
    reset() {
      this.preset = {};
      this.geojson = null;
      this.bounds = null;
    },
    async savePreset() {
      this.preset["preset_id"] = this.preset.id;
      await this.$store.dispatch("UPDATE_PRESET", this.preset);
    },
    deletePreset() {
      this.deleteDialog = true;
    },
    async confirmDeletePreset() {
      this.deleteDialog = false;
      await this.$store.dispatch("DELETE_PRESET", this.preset);
      this.$router.go(-1);
    },
    async onChangeUser(userId) {
      try {
        if (!userId) return;

        try {
          await this.$store.dispatch("FETCH_CONTRACTS", userId);
          let contractResponse = this.$store.getters.CONTRACT_BY_USERID(userId);

          if (!contractResponse) {
            this.contractModel = null;
            return;
          }
          // получаем контракт
          this.contractModel = contractResponse;
          this.coordinateOrder = this.contractModel.preset_settings.coordinate_order;
          // создаем модель для вывода
          this.dvariants = contractResponse.dvariants;
        } catch (e) {
          // toastr.error('Ошибка загрузки договора');
        }
      } catch (e) {
        // eslint-disable-next-line no-undef
      }
    },
    async onChangePreset(presetId) {
      try {
        if (!presetId) return;

        this.preset = await this.$store.dispatch("FETCH_PRESET", {
          presetId: presetId,
          userId: this.userId
        });
        this.geojson = this.$store.getters.PRESET.area;
        this.bounds = this.$refs.geoJsonLayer.getBounds();
      } catch (err) {
        this.$store.dispatch("PUSH_ERROR", err);
      }
    },
    async loadPredicts() {
      if (!this.contractModel.dvariants) return;

      const max = Math.min(
        ...this.contractModel.dvariants.map(d => d.prioritet)
      );
      const dgroup = this.contractModel.dvariants.find(
        m => m.prioritet === max
      );
      this.domain = dgroup.domain;
      if (!dgroup.predicts) return;

      this.predicts = dgroup.predicts;
    },
    async loadParameters() {
      await this.$store.dispatch("FETCH_PARAMETERLAYERS");

      const presetParameters = this.contractModel.pvariants;

      await this.$store.dispatch("FETCH_PARAMETERS");

      this.parameters = uniqWith(
        this.$store.getters.PARAMETERS,
        (pA, pB) => pA.name === pB.name
      );

      presetParameters.forEach(x => {
        x.parameters = this.parameters.filter(z => x.pnames.includes(z.name));
      });

      this.presetParameters = presetParameters;
    }
  }
};
</script>